/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { updatePartnerLogo, setEmbedProperty, setPartnerLogoSrc, setPartnerLogoUrl, toggleShowPartnerLogo, toggleInsticatorBranding } from 'state/actions/embedsState/embedManagementState/selected_embed_status';
import { setContentProperty } from 'state/actions/embedsState/embedManagementState/content_status';
// component
import EmbedProperties from 'pages/dashboard/embeds/management/customize/embedproperties/embedproperties';



/* ========== ~~~~~~~~~~ EMBED PROPERTIES : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState, sessionStatus }) => ({
    accountUUID: sessionStatus.accountUUID,
    mocked: sessionStatus.mocked,
    uploadingCustomImage: embedsState.embedManagementState.contentStatus.uploadingCustomImage,
    partnerLogo: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.partnerLogo,
    brandColor: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.brandColor,
    contentId: embedsState.embedManagementState.contentStatus['selectedContent'],
    showInsticatorBranding: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.showInsticatorBranding,
    showPartnerLogo: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.showPartnerLogo,
    noLiveContents: embedsState.embedManagementState.contentStatus.noLiveContents,
    location: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.location
});

// map actions
const mapDispatchToProps = dispatch => ({
    updatePartnerLogo: (accountUUID, imageFile) => dispatch(updatePartnerLogo(accountUUID, imageFile)),
    setPartnerLogoSrc: logoSource => dispatch(setPartnerLogoSrc(logoSource)),
    setEmbedProperty: (property, value) => dispatch(setEmbedProperty(property, value)),
    toggleInsticatorBranding: () => dispatch(toggleInsticatorBranding()),
    // setContentProperty: (contentId, property, value) => dispatch(setContentProperty(contentId, property, value)),
    setPartnerLogoUrl: url => dispatch(setPartnerLogoUrl(url)),
    toggleShowPartnerLogo: bool => dispatch(toggleShowPartnerLogo(bool))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EmbedProperties);
